import { registerPlugin } from '@capacitor/core';

export type ApexxShareInboxFile = {
	uri: string;
	name: string;
	mimeType: string;
};

export type ApexxShareInboxResult = {
	found: boolean;
	reason?: string;
	appGroupId?: string;
	key?: string;
	title?: string;
	texts?: string[];
	files?: ApexxShareInboxFile[];
	fileCount?: number;
	textCount?: number;
};

export type ApexxShareInboxCopyResult = {
	uri: string;
	name: string;
	size: number;
};

type ApexxShareInboxPlugin = {
	consume: () => Promise<ApexxShareInboxResult>;
	peek: () => Promise<ApexxShareInboxResult>;
	/** Copies an App Group (or other absolute) file into app Caches; returns a file:// URI. */
	copySharedFile: (options: {
		sourceUri: string;
		fileName?: string;
	}) => Promise<ApexxShareInboxCopyResult>;
};

export const ApexxShareInbox = registerPlugin<ApexxShareInboxPlugin>('ApexxShareInbox');
